// 휴대폰 번호
export const phoneNumber = (phone) => {
  try {
    return phone.replace(
      /^(01\d|02|031|032|033|041|042|043|044|051|052|053|054|055|061|062|063|064)(\d{3,4})(\d{4})$/,
      '$1-$2-$3'
    );
  } catch (e) {
    return phone;
  }
};

const seoulDateTimeFormatter = new Intl.DateTimeFormat('sv-SE', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const normalizeUtcDateInput = (value) => {
  if (typeof value !== 'string') return value;

  if (/[zZ]|[+-]\d{2}:\d{2}$/.test(value)) {
    return value;
  }

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
    return value.replace(' ', 'T') + 'Z';
  }

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(value)) {
    return value + 'Z';
  }

  return value;
};

export const formatSeoulDateTime = (value) => {
  if (!value) return '-';

  const date = new Date(normalizeUtcDateInput(value));
  if (Number.isNaN(date.getTime())) return '-';

  const parts = seoulDateTimeFormatter.formatToParts(date);
  const values = parts.reduce((accumulator, part) => {
    if (part.type !== 'literal') {
      accumulator[part.type] = part.value;
    }
    return accumulator;
  }, {});

  return `${values.year}-${values.month}-${values.day} ${values.hour}:${values.minute}:${values.second} (KST, Asia/Seoul)`;
};
